import React from "react";
import Moment from "moment";
import { colorScale } from "AppSrc/dashboards/utils";
import { ReportingPackageStatusItem } from "AppSrc/user/projectItem/reportingPackageStatusItem";

export default function RelatedRefs({ project, depth }) {
  let refs = project.get("related_refs");

  if (!refs?.size) return null;

  let projectId = project.get("uid");

  return refs.map((ref, i) => {
    let refId = ref.get("uid");
    let refName = ref.get("name");
    let dueDate = ref.get("latest_due_date");
    let dates = "No Due Date";
    let color = "#ddd";

    let status = ref?.get("latest_status");
    let isOnHold = status?.startsWith("Not for");

    if (isOnHold) return null;

    if (dueDate && !isOnHold) {
      let dueDateStr = Moment(dueDate).format("Do MMM YY");

      let now = Moment(new Date());
      let diffDays = Moment(dueDate).diff(now, "days");
      let diffDayStr =
        diffDays !== null || diffDays !== undefined
          ? diffDays >= 0
            ? `(${diffDays} days)`
            : `(overdue ${Math.abs(diffDays)} days)`
          : null;
      dates = `Due: ${dueDateStr} ${diffDayStr}`;
      color = colorScale(diffDays / 30)
        .brighten(2)
        .hex();
    }

    return (
      <ReportingPackageStatusItem
        index={i}
        key={i}
        projectId={projectId}
        refId={refId}
        refName={refName}
        status={"Pending Input"}
        color={color}
        dates={dates}
        depth={depth}
      />
    );
  });
}
